import "./ProductsLoadingAnimation.scss";
import { useState, useEffect } from "react";

export const ProductBottleBubbleAnimation = ({
  isApiRequestComplete,
  onDone,
}) => {
  const [apiDone, setApiDone] = useState(false);
  const [minAmountDone, setMinAmountDone] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setMinAmountDone(true), 2000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (isApiRequestComplete === true && minAmountDone === true) {
      setApiDone(true);
      setTimeout(onDone, 1100); // allow fade-out
    }
  }, [minAmountDone, isApiRequestComplete, onDone]);

  return (
    <div className={`product-bottle-svg ${apiDone ? "fade-out" : "fade-in"}`}>
      <svg
        width="83"
        height="121"
        viewBox="0 0 83 111"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M54.4336 31.1172C63.9773 31.1174 71.7139 38.8547 71.7139 48.3984V82.2578C71.7137 85.4452 69.1298 88.0293 65.9424 88.0293H42.9238C39.7364 88.0293 37.1525 85.4452 37.1523 82.2578V48.3984C37.1523 38.8545 44.8897 31.1172 54.4336 31.1172Z"
          stroke="black"
          strokeWidth="2"
          className="animate-path"
          style={{ animationDelay: "0s" }}
        />
        <rect
          x="46.3438"
          y="21.8662"
          width="16.1739"
          height="8.53534"
          rx="3"
          stroke="black"
          strokeWidth="2"
          className="animate-path"
          style={{ animationDelay: "0.1s" }}
        />
        <rect
          x="48.6953"
          y="15.4141"
          width="11.6839"
          height="5.74025"
          rx="2.87012"
          stroke="black"
          strokeWidth="2"
          className="animate-path"
          style={{ animationDelay: "0.2s" }}
        />
        <path
          d="M46.623 15.0527L62.2312 15.0527"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="round"
          className="animate-path"
          style={{ animationDelay: "0.3s" }}
        />
        <path
          d="M49.4326 1.49902C51.7846 1.49902 53.7061 3.4191 53.7061 5.80469C53.7058 8.19006 51.7844 10.1094 49.4326 10.1094C47.081 10.1091 45.1604 8.18991 45.1602 5.80469C45.1602 3.41924 47.0808 1.49925 49.4326 1.49902Z"
          stroke="black"
          strokeWidth="3"
          className="animate-path-bob"
          style={{ animationDelay: "0.5s" }}
        />
        <path
          d="M28.6592 18.499C32.6053 18.499 35.8184 21.7184 35.8184 25.707C35.8182 29.6956 32.6052 32.915 28.6592 32.915C24.7132 32.915 21.5001 29.6955 21.5 25.707C21.5 21.7184 24.7131 18.4991 28.6592 18.499Z"
          stroke="black"
          strokeWidth="3"
          className="animate-path-bob"
          style={{ animationDelay: "0.6s" }}
        />
        <path
          d="M73.4072 38.499C77.7665 38.499 81.3152 42.0549 81.3154 46.459C81.3154 50.8632 77.7666 54.4199 73.4072 54.4199C69.048 54.4197 65.5 50.8631 65.5 46.459C65.5002 42.055 69.0481 38.4993 73.4072 38.499Z"
          stroke="black"
          strokeWidth="3"
          className="animate-path-bob"
          style={{ animationDelay: "0.7s" }}
        />
        <path
          d="M22.6175 88.6289L2 109.334M16.7869 75.0332C16.7869 85.5449 25.2722 94.0664 35.7393 94.0664C46.2064 94.0664 54.6917 85.5449 54.6917 75.0332C54.6917 64.5214 46.2064 56 35.7393 56C25.2722 56 16.7869 64.5214 16.7869 75.0332Z"
          stroke="black"
          strokeWidth="3"
          strokeLinecap="round"
          className="animate-path-orbit"
          style={{ animationDelay: "0.8s" }}
        />
      </svg>
    </div>
  );
};
